import React from 'react'

import { Text } from '@wartek-id/text-v1'

type ItemListProps = {
  items: {
    label: string
    onClick: () => void
  }[]
}

const ItemList = ({ items }: ItemListProps) => {
  return (
    <ul className="py-3 space-y-1.5">
      {items.map(({ label, onClick }, index) => (
        <li key={index} onClick={() => onClick()}>
          <Text
            variant="body-bold"
            className="cursor-pointer hover:!text-white"
            color="inverse-subdued"
          >
            {label}
          </Text>
        </li>
      ))}
    </ul>
  )
}

export default ItemList
